import { render, staticRenderFns } from "./CreateGlLevel2Form.vue?vue&type=template&id=e5199ab0&scoped=true&"
import script from "./CreateGlLevel2Form.vue?vue&type=script&lang=js&"
export * from "./CreateGlLevel2Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5199ab0",
  null
  
)

export default component.exports